module.exports = __webpack_public_path__ + "static/media/spilling2.bb14f538.mp4";